import React from 'react';
import { Spin } from '@nackle/paper';

export const SlackIcon = ( { ...props } ) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <circle fill="#fff" cx="12" cy="12" r="12" />
    <path
      fill="#40c5ee"
      d="M9.75,8h-4a1.75,1.75,0,0,0,0,3.5h4a1.75,1.75,0,0,0,0-3.5Z"
    />
    <path
      fill="#40c5ee"
      d="M9.75,4a1.75,1.75,0,0,0,0,3.5H11.5V5.75A1.75,1.75,0,0,0,9.75,4Z"
    />
    <path
      fill="#de245c"
      d="M8.25,14v4a1.75,1.75,0,0,0,3.5,0V14a1.75,1.75,0,0,0-3.5,0Z"
    />
    <path
      fill="#de245c"
      d="M4.25,14a1.75,1.75,0,0,0,3.5,0V12.25H6A1.75,1.75,0,0,0,4.25,14Z"
    />
    <path
      fill="#ebb13e"
      d="M14.25,16h4a1.75,1.75,0,0,0,0-3.5h-4a1.75,1.75,0,0,0,0,3.5Z"
    />
    <path
      fill="#ebb13e"
      d="M14.25,20a1.75,1.75,0,0,0,0-3.5H12.5v1.75A1.75,1.75,0,0,0,14.25,20Z"
    />
    <path
      fill="#37b57f"
      d="M16,10V6a1.75,1.75,0,0,0-3.5,0v4A1.75,1.75,0,0,0,16,10Z"
    />
    <path
      fill="#37b57f"
      d="M20,10a1.75,1.75,0,0,0-3.5,0v1.75h1.75A1.75,1.75,0,0,0,20,10Z"
    />
  </svg>
);

export const ErrorIcon = ( { ...props } ) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <circle fill="#b22222" cx="12" cy="12" r="12" />
    <polygon
      fill="#fff"
      points="16.6 5.28 12 9.88 7.4 5.28 5.28 7.4 9.88 12 5.28 16.6 7.4 18.72 12 14.12 16.6 18.72 18.72 16.6 14.12 12 18.72 7.4 16.6 5.28"
    />
  </svg>
);

export const EcardLoading = ( { content } ) => (
  <div className="card-loading-container">
    <Spin
      tip={ content ? content : 'Loading Ecard Studio...' }
      className="card-loading"
    ></Spin>
  </div>
);
